var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"share-widget__link share-widget__clipboard",class:[{ 'active': this.active}],attrs:{"rel":"noopener noreferrer","title":_vm.title,"href":"#"},on:{"click":_vm.onClick}},[_c('Icon',{attrs:{"name":"link"}}),_c('span',{staticClass:"share-widget__clipboard-label"},[_vm._v(_vm._s(_vm.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }